// extracted by mini-css-extract-plugin
export default {"container":"p0yFnI5"};